import { useForm } from "react-hook-form";

const useCustomForm = () => useForm({
	mode: "all",
	reValidateMode: "onBlur"
});

export default useCustomForm;